/*
 * Copyright (C) 2021 Bosch.IO GmbH. All rights reserved.
 */
import React from 'react';
import styled from 'styled-components';
import { BladeBoxProps } from './types';

export const BladeBox = React.forwardRef<HTMLDivElement, BladeBoxProps>(
    ({ children, ...rest }, ref) => {
        return (
            <StyledBladeBox ref={ref} {...rest}>
                {children}
            </StyledBladeBox>
        );
    },
);

BladeBox.displayName = 'BladeBox';

const StyledBladeBox = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    min-height: 100%;
    overflow: auto hidden;
    display: flex;
    border-top: 1px solid var(--plain__disabled__front__default);
    background-color: var(--background);
`;
